export default __webpack_public_path__ + "static/media/white.495ae436.png";